import React from "react";
import { Stack, TextField } from "@mui/material";
import { OperandBuilder } from "../OperandBuilder";
import type { RuleComponentProps } from "./types";

export const RuleContains: React.FC<RuleComponentProps> = ({
    value,
    onChange,
    evaluationDomain,
    declaredDerivedAttributeNames = [],
}) => {
    const c = value?.contains;
    const left = c?.left ?? { value: "" };
    const substr = c?.substr ?? "";

    const updateLeft = (op: import("../../../../../../types/resolver").OperandDto | null) => {
        onChange({ contains: { ...c, left: op ?? { value: "" }, substr } });
    };

    const updateSubstr = (str: string) => {
        onChange({ contains: { ...c, left, substr: str } });
    };

    return (
        <Stack spacing={1}>
            <OperandBuilder
                label="Left"
                side="left"
                value={left}
                onChange={updateLeft}
                evaluationDomain={evaluationDomain}
                declaredDerivedAttributeNames={declaredDerivedAttributeNames}
                leftOperandTypes="keyOnly"
            />
            <TextField
                size="small"
                label="Substring"
                value={substr}
                onChange={(e) => updateSubstr(e.target.value)}
            />
        </Stack>
    );
};
